module.exports = __webpack_public_path__ + "static/nslide1-ff2e18fa5ac7f0ba5eff171ab5f133e7.png";